/*
 * Handles the exporting display shown when downloading a report to CSV.
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/downloadDisplay/downloadDisplayView",
  "modules/shared/progressBar/progressBarModule",
], function (Marionette, Messenger, DownloadDisplayView, ProgressBarModule) {
  //used as context for the timer
  var _this;
  var DownloadDisplayModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "downloadDisplay";
      this.region = options.region;
      this._setUpVents();
      _this = this;
    },
    show: function () {
      _this.layout = new DownloadDisplayView.downloadDisplayLayout();
      _this.region.backdrop = "static"; //do not allow the modal to close on background click
      delete _this.timerId; //get rid of timer id
      // Add the progress bar with the label and class to display correctly when downloading a table (vs loading it)
      _this.progressBar = _this.addSubModule(
        new ProgressBarModule({
          region: _this.layout.progressBar,
          label: "reports.downloading",
          className: "report-progress-downloading",
        }),
      );
      _this.layout.on(
        "show",
        function () {
          _this._showSubViews();
        },
        _this,
      );
      _this.showRegion(_this.layout);
    },
    _showSubViews: function () {
      _this.progressBar.show();
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:download:display",
        function () {
          this.timerId = window.setTimeout(_this.show, 0);
        },
        this,
      );

      Messenger.vent.on(
        "close:download:display",
        function () {
          //clear timer
          if (this.timerId) {
            window.clearTimeout(this.timerId);
            delete this.timerId;
          } else {
            this.region.$el.modal("hide");
          }
        },
        this,
      );
    },
  });

  return DownloadDisplayModule;
});
